<template>
  <span>
    <i v-if="customer.company==null" class="mdi mdi-account-circle align-vertical-middle"></i>
    <i v-else class="mdi mdi-city align-vertical-middle"></i>
    <span class="secondary-text" style="margin-left:5px; font-size: 13px">{{ customerName(customer)}}</span>
    <span class="secondary-text" v-if="customerEmail(customer)"> ({{customerEmail(customer)}})</span>
  </span>
</template>
<script>
import customerUtil from '@/utils/customer-util.js'
export default {

	name: 'Customer-Select-item',
  props: {
    customer : {type : Object}
	},
  data() {
    return {

    };
  },
  methods : {
    customerEmail(customer){
      return customerUtil.customerEmail(customer);
    },
    customerName(customer){
      return customerUtil.customerName(customer.name, customer.usual_name != null ? customer.usual_name :customer.usualName)
    }
  },
	computed : {

	},
  mounted(){

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


</style>
